import { ValidTicket } from "@ds/illustrations";
import { Accordion, Table } from "@ruter-as/web-components-and-tools";
import CarIllustration from "../../gfx/carIllustration";
import "./SubscriptionInfoSummary.scss";

interface Props {
	hasTravelSubscription: boolean;
	title: React.JSX.Element;
	className?: string;
	isHousingCooperative: boolean;
}

const SubscriptionInfoSummary: React.FC<Props> = ({
	hasTravelSubscription,
	title,
	className,
	isHousingCooperative,
}) => {
	const cn = ["components-wrapper-subscription-info-summary", className];

	const getCarPoolText = () => {
		if (hasTravelSubscription) {
			return (
				<p>
					Inkludert i abonnementet er også 200 kr i leiebil-rabatt hver måned
					(med rollover opptil 600 kr). Rabattkodene får du på SMS den 1. hver
					måned og kan benyttes hos Bilkollektivet, Hyre eller Getaround.
					Kjøretøyene booker du i leverandørens apper, der du har tilgang på
					ulike biltyper, inkludert varebil, SUV osv.
				</p>
			);
		} else {
			return (
				<>
					<p>
						For 49 kr i måneden får du 200 kr i rabattkode hver måned (rollover
						opptil 600 kr). Når du bruker rabatten hos Getaround, Hyre eller
						Bilkollektivet, starter du opptjening av ny rabatt. Bruker leiebil
						bare én gang i året vil avtalen normalt lønne seg for deg.
					</p>
					<p>
						Book kjøretøy via leverandørenes apper. I ferietid kan det være lurt
						å være ute i god tid med bestilling. Du får tilgang til ulike
						biltyper, inkludert varebil.
					</p>
				</>
			);
		}
	};

	return (
		<div className={cn.join(" ")}>
			{title}
			<p>
				{isHousingCooperative
					? "Som beboer i utvalgte borettslag får du tilgang til "
					: "Som ansatt i utvalgte bedrifter får du tilgang til "}
				{hasTravelSubscription ? "ett smart " : "to smarte "}
				abonnement til en gunstig pris.
				{isHousingCooperative
					? " Beboere i borettslag betaler via faktura, avtalegiro eller e-faktura."
					: " Bedriftsdeltakere trekkes i lønn månedlig."}
			</p>
			<Accordion className="accordion">
				<Accordion.Item
					title={
						<div className="accordion-label">
							<div className="illustration-container" aria-hidden={true}>
								<ValidTicket />
							</div>
							<p>Lavere pris på månedsbillett!</p>
						</div>
					}
				>
					<p>
						{isHousingCooperative
							? "Med Ruters månedsbillett for borettslag "
							: "Med Ruters månedsbillett for bedrifter "}
						reiser du rimeligere.
					</p>
					<Table
						headerCells={["", "Pris", "Spar"]}
						rows={[
							{ key: "Sone 1", cells: ["Sone 1 (Oslo)", "671,-", "100,-"] },
							{ key: "1 sone", cells: ["1 sone", "849,-", "150,-"] },
							{ key: "2 soner", cells: ["2 soner", "1505,-", "300,-"] },
							{
								key: "Alle soner",
								cells: ["Alle soner", "2165,-", "400,-"],
							},
						]}
					/>
					<p>
						Du bestiller og administrerer billetten selv. Du får billetten i
						Ruter-appen og den fungerer som et abonnement. Du slipper å huske å
						fornye billetten - det går automatisk. Når du bestiller, vil
						billetten gjelde fra og med neste kalendermåned. Du kan ikke
						bestille for innværende måned. Billetten er gyldig som en ordinær
						Ruter-billett, på buss, trikk, T-bane, båt og tog (ikke Flytoget)
						for ønskede soner i Oslo og Akershus.
					</p>
				</Accordion.Item>
				<Accordion.Item
					title={
						<div className="accordion-label">
							<div className="illustration-container" aria-hidden={true}>
								<CarIllustration />
							</div>
							<p>Rabatt på leiebil!</p>
						</div>
					}
				>
					{getCarPoolText()}
				</Accordion.Item>
			</Accordion>
		</div>
	);
};

export default SubscriptionInfoSummary;
